import { useIsMobileScreen } from "@/hooks/useScreenSize";

type LogoProps = {
  path: string;
  styles?: React.CSSProperties;
};

const Logo = ({ path, styles }: LogoProps) => {
  const isMobile = useIsMobileScreen();

  return (
      <img
        itemProp="image"
        width={isMobile ? 75 : 115}
        height={isMobile ? 25 : 35}
        src={path}
        style={styles}
        alt="Tulu Logo"
      />
  );
};

export default Logo;
